import React, { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { toast } from 'react-hot-toast';
import { api, endpoints } from '../apiConfig';
import styles from './ResumeUploader.module.css';

const ResumeUploader = ({ onUploadComplete }) => {
  const [isUploading, setIsUploading] = useState(false);

  const onDrop = useCallback(async (acceptedFiles) => {
    if (acceptedFiles.length === 0) {
      toast.error('Please select a valid resume file');
      return;
    }

    const file = acceptedFiles[0];
    const formData = new FormData();
    formData.append('resume', file);

    setIsUploading(true);
    try {
      const response = await api.post(endpoints.resume.upload, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data && response.data.data) {
        toast.success('Resume uploaded successfully');
        onUploadComplete(response.data.data);
      } else {
        throw new Error('Invalid response from server');
      }
    } catch (error) {
      console.error('Resume upload error:', error);
      toast.error(error.response?.data?.error || 'Failed to upload resume');
    } finally {
      setIsUploading(false);
    }
  }, [onUploadComplete]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'application/pdf': ['.pdf'],
      'application/msword': ['.doc'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx']
    },
    maxFiles: 1,
    maxSize: 5 * 1024 * 1024 // 5MB
  });

  return (
    <div className={styles.container}>
      <div
        {...getRootProps()}
        className={`${styles.dropzone} ${isDragActive ? styles.active : ''} ${isUploading ? styles.uploading : ''}`}
      >
        <input {...getInputProps()} />
        {isUploading ? (
          <div className={styles.uploadingState}>
            <div className={styles.spinner}></div>
            <p>Uploading resume...</p>
          </div>
        ) : isDragActive ? (
          <p>Drop your resume here</p>
        ) : (
          <div className={styles.uploadPrompt}>
            <div className={styles.icon}>📄</div>
            <p>Drag and drop your resume here or click to browse</p>
            <span className={styles.supportedFormats}>
              Supported formats: PDF, DOC, DOCX
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResumeUploader; 